import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class EditButtonModel extends ButtonBase {
    label: string = 'Edit';
    action: string = ACTION_STATUS.edit;
    matIconName: string = 'edit';
    colorClass: string = 'color-warning-500';
}